// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-box {
  background: #fff;
  overflow: hidden;
  border: 1px solid #e3e3e2;
  padding: 8px;
  position: relative;
  height: 100%;
  border-radius: 5px;
}
.item-box .details-box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  height: 100%;
}
.item-box .details-box .image-box {
  height: 140px;
  order: 0;
  overflow: hidden;
}
.item-box .details-box .title {
  font-size: 1rem;
  line-height: 1;
  min-height: 33px;
  order: 1;
}
.item-box .details-box .desc-box {
  overflow: hidden;
  text-align: start;
  min-height: 95px;
  order: 3;
}
.item-box .details-box .properties-box {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  order: 2;
  align-items: center;
}
.item-box .details-box .properties-box .maker-img {
  height: 30px;
  line-height: 0.7;
}
.item-box .details-box .properties-box .maker-img span {
  font-size: 13px;
}
.item-box .details-box .props-content {
  order: 8;
  font-size: 12px;
  overflow: hidden;
  flex: 1;
}
.item-box .details-box .props-content .props-box {
  display: flex;
  gap: 0px 7px;
  flex-wrap: wrap;
  position: absolute;
}
.item-box .details-box .options-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  order: 4;
}
.item-box .details-box .options-box .cart-options {
  flex: auto;
}
.item-box .details-box .options-box .cart-options ion-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}
.item-box .details-box .options-box .cart-options ion-buttons ion-button {
  width: 100%;
  font-size: 12px;
  height: 35px;
  background: none;
  --background: none;
  font-weight: bold;
  --padding-end: 0;
  --padding-start: 0;
}
.item-box .details-box .options-box .cart-options ion-buttons.btn-outline {
  border: 1px solid #f5f5f5;
  border-radius: 4px;
}
.item-box .details-box .options-box .cart-options ion-buttons.btn-outline ion-button {
  color: #565656 !important;
}
.item-box .details-box .options-box .cart-options ion-buttons.btn-outline ion-button.danger {
  color: #c97f7f !important;
}
.item-box .details-box .options-box .price-box {
  flex: 0 0 33%;
  height: auto;
  font-weight: bold;
  text-align: center;
  font-size: 1.2rem;
  color: #565656;
  justify-content: center;
}
.item-box .details-box .options-box .price-box ::ng-deep .price-div {
  line-height: 1;
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}
.item-box .details-box .options-box .price-box ::ng-deep .oldprice {
  font-size: 15px;
  color: #aeaead;
  font-weight: initial;
}
.item-box .details-box .agent-tool-box {
  order: 5;
}
.item-box .sale-span {
  position: absolute;
  top: -1px;
  right: -2px;
  left: auto;
  max-height: 34px;
  max-width: 120px;
  z-index: 1111;
}
.item-box .sale-span ion-badge {
  font-weight: bolder;
  padding: 4px;
  font-size: 14px;
  white-space: pre-line;
}
.item-box .sale-span.last-price {
  top: 0;
  left: 5px;
  right: inherit;
  bottom: inherit;
  align-items: flex-start;
}
.item-box .sale-span.last-price ion-badge {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  font-size: 17px;
  display: flex;
  gap: 5px;
  font-weight: 100;
}

ion-badge {
  --color: #3c3c3c;
  --background: #f9f9f9;
}

.item-box.smaller .details-box .image-box {
  height: 50px;
  order: 0;
  overflow: hidden;
}

.item-box.bigger .details-box .image-box {
  height: 200px;
  order: 0;
  overflow: hidden;
}

@media (min-width: 450px) {
  .item-box.smaller .details-box .image-box {
    height: 95px;
    order: 0;
    overflow: hidden;
  }
}
.item-box.small .details-box {
  flex-flow: column wrap;
  height: 104px;
}
.item-box.small .details-box .image-box {
  flex: 1 0 100%;
  width: 25%;
}
.item-box.small .details-box .title, .item-box.small .details-box .desc-box, .item-box.small .details-box .options-box, .item-box.small .details-box .agent-tool-box, .item-box.small .details-box .properties-box {
  min-height: inherit;
  flex: 1;
  width: 75%;
}
.item-box.small .details-box .agent-tool-box ::ng-deep app-item-agent-tool .flex-grid {
  flex-wrap: nowrap;
  overflow-x: auto;
}
.item-box.small .details-box .agent-tool-box ::ng-deep app-item-agent-tool .flex-grid .grid-box {
  flex: 1 0 auto;
}
.item-box.small .details-box .options-box {
  margin-top: 5px;
}
.item-box.small .details-box .options-box .price-box {
  max-height: 37px;
}
.item-box.small .details-box .options-box .price-box ::ng-deep .price-div {
  flex-direction: column;
  align-items: center;
  gap: 0;
}
.item-box.small .details-box .options-box .price-box ::ng-deep .price-div .oldprice {
  font-size: 15px;
}

.packageUnits {
  font-size: 12px;
  word-wrap: break-word;
  font-style: italic;
  text-align: center;
  padding: 4px 10px;
  line-height: 0.8;
  /* margin: 1px 4px; */
  width: min-content;
  border-radius: 7px;
  color: #3c3c3c;
  background: #f9f9f9;
}

.item-box.big .details-box .options-box {
  flex-direction: column-reverse;
  align-items: flex-end;
  gap: 2px;
  margin-top: 5px;
}
.item-box.big .details-box .options-box .cart-options {
  width: 100%;
}
.item-box.big .details-box .options-box .price-box {
  width: -moz-fit-content;
  width: fit-content;
}
.item-box.big .details-box .options-box .price-box .flex-column {
  flex-direction: initial !important;
  gap: 10px;
}

.item-box.small.agent-tool .details-box {
  height: 120px;
}
.item-box.small.agent-tool .details-box .title, .item-box.small.agent-tool .details-box .properties-box {
  max-height: 20px;
  font-size: 13px;
  white-space: nowrap;
}

.item-box.inCart {
  border-color: var(--button-a-background);
}

ion-badge.unit-price {
  font-weight: 100;
  gap: 2px;
}
ion-badge.unit-price ::ng-deep .price-div .oldprice {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/item-box/item-box.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;EAEA,eAAA;EACA,sBAAA;EACA,YAAA;AADJ;AAII;EAEE,aAAA;EACA,QAAA;EACA,gBAAA;AAHN;AAMI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;AAJN;AAOI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,QAAA;AANN;AASI;EACE,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AARN;AAUM;EAEE,YAAA;EACA,gBAAA;AATR;AAWQ;EACE,eAAA;AATV;AAcI;EACE,QAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;AAZN;AAcM;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAZR;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;EACA,gBAAA;EAEA,QAAA;AAjBN;AAmBM;EACE,UAAA;AAjBR;AAmBQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAjBV;AAmBU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EAGA,gBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,kBAAA;AApBZ;AAwBQ;EACE,yBAAA;EACA,kBAAA;AAtBV;AAwBU;EACE,yBAAA;AAtBZ;AAyBU;EACE,yBAAA;AAvBZ;AA4BM;EACE,aAAA;EAEA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EAEA,uBAAA;AA7BR;AAgCU;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AA9BZ;AAiCU;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AA/BZ;AAqCI;EACE,QAAA;AAnCN;AAuCE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AArCJ;AAuCI;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AArCN;AA0CE;EACE,MAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAxCJ;AA0CI;EACE,+BAAA;EACA,8BAAA;EACA,yBAAA;EACA,0BAAA;EAEA,eAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAzCN;;AA+CA;EAGE,gBAAA;EACA,qBAAA;AA9CF;;AAmDI;EAEE,YAAA;EACA,QAAA;EACA,gBAAA;AAjDN;;AAwDI;EAEE,aAAA;EACA,QAAA;EACA,gBAAA;AAtDN;;AA2DA;EAIM;IAEE,YAAA;IACA,QAAA;IACA,gBAAA;EA5DN;AACF;AAmEE;EACE,sBAAA;EACA,aAAA;AAjEJ;AAmEI;EACE,cAAA;EACA,UAAA;AAjEN;AAqEI;EACE,mBAAA;EACA,OAAA;EAEA,UAAA;AApEN;AAyEQ;EACE,iBAAA;EACA,gBAAA;AAvEV;AAyEU;EACE,cAAA;AAvEZ;AA6EI;EACE,eAAA;AA3EN;AA6EM;EACE,gBAAA;AA3ER;AA8EU;EACE,sBAAA;EACA,mBAAA;EACA,MAAA;AA5EZ;AA8EY;EACE,eAAA;AA5Ed;;AAsFA;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAnFF;;AA0FI;EACE,8BAAA;EACA,qBAAA;EACA,QAAA;EAEA,eAAA;AAxFN;AA0FM;EACE,WAAA;AAxFR;AA2FM;EACE,uBAAA;EAAA,kBAAA;AAzFR;AA2FQ;EACE,kCAAA;EACA,SAAA;AAzFV;;AAkGE;EACE,aAAA;AA/FJ;AAiGI;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AA/FN;;AAoGA;EACE,wCAAA;AAjGF;;AAoGA;EACE,gBAAA;EACA,QAAA;AAjGF;AAqGM;EACE,0BAAA;AAnGR","sourcesContent":[".item-box {\n  background: #fff;\n  //background: linear-gradient(6deg, #fcf5f5 0%, #ffffff 59%, #ffffff 267%, white 100%);\n  overflow: hidden;\n  border: 1px solid #e3e3e2;\n  padding: 8px;\n  position: relative;\n  height: 100%;\n  border-radius: 5px;\n\n  .details-box {\n    display: flex;\n    //justify-content: space-between;\n    flex-wrap: wrap;\n    flex-direction: column;\n    height: 100%;\n    //gap: 2px;\n\n    .image-box {\n      //width: 15%;\n      height: 140px;\n      order: 0;\n      overflow: hidden;\n    }\n\n    .title {\n      font-size: 1rem;\n      line-height: 1;\n      min-height: 33px;\n      order: 1;\n    }\n\n    .desc-box {\n      overflow: hidden;\n      text-align: start;\n      min-height: 95px;\n\n      order: 3;\n    }\n\n    .properties-box {\n      display: flex;\n      //align-items: center;\n      justify-content: space-between;\n      flex-direction: row;\n      order: 2;\n      align-items: center;\n\n      .maker-img {\n        //padding: 3px;\n        height: 30px;\n        line-height: 0.7;\n\n        span {\n          font-size: 13px;\n        }\n      }\n    }\n\n    .props-content {\n      order: 8;\n      font-size: 12px;\n      overflow: hidden;\n      flex: 1;\n\n      .props-box {\n        display: flex;\n        gap: 0px 7px;\n        flex-wrap: wrap;\n        position: absolute;\n      }\n    }\n\n\n    .options-box {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      //margin-top: 2px;\n      align-items: center;\n      margin-top: auto;\n\n      order: 4;\n\n      .cart-options {\n        flex: auto;\n\n        ion-buttons {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          overflow: hidden;\n\n          ion-button {\n            width: 100%;\n            font-size: 12px;\n            height: 35px;\n            //max-width: 150px;\n\n            background: none;\n            --background: none;\n\n            font-weight: bold;\n            --padding-end: 0;\n            --padding-start: 0;\n          }\n        }\n\n        ion-buttons.btn-outline {\n          border: 1px solid #f5f5f5;\n          border-radius: 4px;\n\n          ion-button {\n            color: #565656 !important;\n          }\n\n          ion-button.danger {\n            color: #c97f7f !important;\n          }\n        }\n      }\n\n      .price-box {\n        flex: 0 0 33%;\n\n        height: auto;\n\n        font-weight: bold;\n        text-align: center;\n        font-size: 1.2rem;\n        color: #565656;\n\n        justify-content: center;\n\n        ::ng-deep {\n          .price-div {\n            line-height: 1;\n            display: flex;\n            gap: 5px;\n            flex-direction: row;\n            justify-content: center;\n            align-items: flex-end;\n          }\n\n          .oldprice {\n            font-size: 15px;\n            color: #aeaead;\n            font-weight: initial;\n          }\n        }\n      }\n    }\n\n    .agent-tool-box {\n      order: 5;\n    }\n  }\n\n  .sale-span {\n    position: absolute;\n    top: -1px;\n    right: -2px;\n    left: auto;\n    max-height: 34px;\n    max-width: 120px;\n    z-index: 1111;\n\n    ion-badge {\n      font-weight: bolder;\n      padding: 4px;\n      font-size: 14px;\n      white-space: pre-line;\n    }\n  }\n\n\n  .sale-span.last-price {\n    top: 0;\n    left: 5px;\n    right: inherit;\n    bottom: inherit;\n    align-items: flex-start;\n\n    ion-badge {\n      border-bottom-right-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n\n      font-size: 17px;\n      display: flex;\n      gap: 5px;\n      font-weight: 100;\n    }\n  }\n\n}\n\nion-badge {\n  //--background: var(--button-b-background);\n  //--color: var(--button-b-text);\n  --color: #3c3c3c;\n  --background: #f9f9f9;\n}\n\n.item-box.smaller {\n  .details-box {\n    .image-box {\n      //width: 15%;\n      height: 50px;\n      order: 0;\n      overflow: hidden;\n    }\n  }\n}\n\n.item-box.bigger {\n  .details-box {\n    .image-box {\n      //width: 15%;\n      height: 200px;\n      order: 0;\n      overflow: hidden;\n    }\n  }\n}\n\n@media (min-width: 450px) {\n\n  .item-box.smaller {\n    .details-box {\n      .image-box {\n        //width: 15%;\n        height: 95px;\n        order: 0;\n        overflow: hidden;\n      }\n    }\n  }\n}\n\n.item-box.small {\n\n  .details-box {\n    flex-flow: column wrap;\n    height: 104px;\n\n    .image-box {\n      flex: 1 0 100%;\n      width: 25%;\n      //max-width: 120px;\n    }\n\n    .title, .desc-box, .options-box, .agent-tool-box, .properties-box {\n      min-height: inherit;\n      flex: 1;\n      //width: -webkit-fill-available;\n      width: 75%;\n    }\n\n    .agent-tool-box {\n      ::ng-deep {\n        app-item-agent-tool .flex-grid {\n          flex-wrap: nowrap;\n          overflow-x: auto;\n\n          .grid-box {\n            flex: 1 0 auto;\n          }\n        }\n      }\n    }\n\n    .options-box {\n      margin-top: 5px;\n\n      .price-box {\n        max-height: 37px;\n\n        ::ng-deep {\n          .price-div {\n            flex-direction: column;\n            align-items: center;\n            gap: 0;\n\n            .oldprice {\n              font-size: 15px;\n            }\n          }\n        }\n      }\n    }\n\n  }\n}\n\n.packageUnits {\n  font-size: 12px;\n  word-wrap: break-word;\n  font-style: italic;\n  text-align: center;\n  padding: 4px 10px;\n  line-height: 0.8;\n  /* margin: 1px 4px; */\n  width: min-content;\n  border-radius: 7px;\n  color: #3c3c3c;\n  background: #f9f9f9;\n\n}\n\n.item-box.big {\n\n  .details-box {\n    .options-box {\n      flex-direction: column-reverse;\n      align-items: flex-end;\n      gap: 2px;\n\n      margin-top: 5px;\n\n      .cart-options {\n        width: 100%;\n      }\n\n      .price-box {\n        width: fit-content;\n\n        .flex-column {\n          flex-direction: initial !important;\n          gap: 10px;\n        }\n      }\n    }\n  }\n}\n\n\n.item-box.small.agent-tool {\n  .details-box {\n    height: 120px;\n\n    .title, .properties-box {\n      max-height: 20px;\n      font-size: 13px;\n      white-space: nowrap;\n    }\n  }\n}\n\n.item-box.inCart {\n  border-color: var(--button-a-background);\n}\n\nion-badge.unit-price {\n  font-weight: 100;\n  gap: 2px;\n\n  ::ng-deep {\n    .price-div {\n      .oldprice {\n        font-size: 12px !important;\n      }\n    }\n  }\n}\n\n//\n//@media (max-width: 545px) {\n//  .item-box.small.agent-tool {\n//    .details-box {\n//      height: 140px;\n//\n//      .agent-tool-box {\n//        ::ng-deep {\n//          app-item-agent-tool .flex-grid {\n//            flex-wrap: wrap;\n//            overflow-x: inherit;\n//          }\n//        }\n//      }\n//    }\n//  }\n//}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
